import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import api from '../../lib/api';
import { Trophy, Calendar, Loader2, ArrowRight } from 'lucide-react';

export const ChallengesPublicPage = () => {
  const [challenges, setChallenges] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const load = async () => {
      try {
        const res = await api.get('/challenges', { params: { public_only: true } });
        setChallenges(res.data || []);
      } catch (err) { console.error(err); }
      finally { setLoading(false); }
    };
    load();
  }, []);

  const formatDate = (iso) => {
    if (!iso) return '';
    const d = new Date(iso);
    if (isNaN(d.getTime())) return iso.slice(0, 10);
    return d.toLocaleDateString('it-IT', { day: '2-digit', month: 'short', year: 'numeric' });
  };

  if (loading) return <div className="min-h-screen flex items-center justify-center"><Loader2 className="animate-spin text-primary" size={32} /></div>;

  return (
    <div className="min-h-screen pt-24 pb-16 px-6" data-testid="challenges-public-page">
      <div className="max-w-5xl mx-auto space-y-10">
        <div className="text-center space-y-3">
          <Trophy size={36} className="mx-auto text-primary" />
          <h1 className="font-heading text-4xl font-bold">Startup Challenge</h1>
          <p className="text-muted-foreground max-w-xl mx-auto">Scopri le challenge di SIOS e scegli quale esplorare</p>
        </div>

        {challenges.length === 0 ? (
          <p className="text-center text-muted-foreground py-12">Nessuna challenge attiva al momento</p>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
            {challenges.map(ch => (
              <Link
                key={ch.id}
                to={`/challenges/${ch.slug || ch.id}`}
                className="group glass rounded-2xl p-6 hover:border-primary/50 transition-all flex flex-col gap-3"
                data-testid={`challenge-card-${ch.id}`}
              >
                <div className="flex items-start justify-between gap-3">
                  <h2 className="font-heading text-xl font-bold leading-tight">{ch.title}</h2>
                  <ArrowRight size={18} className="text-muted-foreground group-hover:text-primary group-hover:translate-x-0.5 transition-all flex-shrink-0 mt-1" />
                </div>
                {ch.description && (
                  <p className="text-sm text-muted-foreground line-clamp-3">{ch.description}</p>
                )}
                {ch.start_time && (
                  <p className="text-xs text-muted-foreground inline-flex items-center gap-1.5 mt-auto pt-2">
                    <Calendar size={12} />
                    {formatDate(ch.start_time)} — {formatDate(ch.end_time)}
                  </p>
                )}
              </Link>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};
